export const EXIT_IMAGES = [
  require("@/assets/images/exit/1.jpeg"),
  require("@/assets/images/exit/2.gif"),
  require("@/assets/images/exit/3.jpeg"),
  require("@/assets/images/exit/4.jpeg"),
  require("@/assets/images/exit/5.jpeg"),
  require("@/assets/images/exit/6.jpeg"),
  require("@/assets/images/exit/7.jpeg"),
  require("@/assets/images/exit/8.jpg"),
  require("@/assets/images/exit/9.png"),
  require("@/assets/images/exit/10.jpeg"),
  require("@/assets/images/exit/11.jpeg"),
  require("@/assets/images/exit/12.jpeg"),
  require("@/assets/images/exit/13.jpeg"),
  require("@/assets/images/exit/14.jpeg"),
  require("@/assets/images/exit/15.jpeg"),
  require("@/assets/images/exit/16.jpeg"),
  require("@/assets/images/exit/17.jpeg"),
  require("@/assets/images/exit/18.jpeg"),
  require("@/assets/images/exit/19.jpeg"),
  require("@/assets/images/exit/20.jpeg"),
  require("@/assets/images/exit/21.gif"),
  require("@/assets/images/exit/22.jpeg"),
  require("@/assets/images/exit/23.jpeg"),
];

export const WELCOME_IMAGES = [
  require("@/assets/images/welcome/1.gif"),
  require("@/assets/images/welcome/2.gif"),
  require("@/assets/images/welcome/3.png"),
  require("@/assets/images/welcome/4.jpg"),
  require("@/assets/images/welcome/5.jpeg"),
  require("@/assets/images/welcome/6.jpeg"),
  require("@/assets/images/welcome/7.jpeg"),
  require("@/assets/images/welcome/8.jpeg"),
  require("@/assets/images/welcome/9.jpeg"),
  require("@/assets/images/welcome/10.jpeg"),
  require("@/assets/images/welcome/11.jpg"),
  require("@/assets/images/welcome/12.jpg"),
  require("@/assets/images/welcome/13.jpg"),
  require("@/assets/images/welcome/14.jpg"),
  require("@/assets/images/welcome/15.gif"),
  require("@/assets/images/welcome/16.jpg"),
  require("@/assets/images/welcome/17.png"),
];
